export default __webpack_public_path__ + "maps-examples-offline-pack-thumbnail-960-831e0c83b1ce64b056e25104bf51c515.webp";